module.exports = __webpack_public_path__ + "img/7-full-sm.0510eb25.jpg";